module.exports = __webpack_public_path__ + "img/boost-score.c65628c1.svg";